import React from "react";
import { Skeleton } from "@/lib/components/ui/skeleton";
import { formatCurrency } from "@/lib/utils";
import { useRates } from "@/lib/hooks/use-rates";
import { useStytchUser } from "@stytch/react";
import { useTotalBalance } from "@/lib/hooks/use-total-balance";
import { useWidget } from "@/lib/hooks/use-widget";

const TotalBalance = () => {
  const { isLoading: isRatesLoading } = useRates();
  const { isLoading: isBalancesLoading } = useWidget();
  const { user } = useStytchUser();

  const currency = (user?.untrusted_metadata.currency as string) || "USD";
  const totalBalance = useTotalBalance();

  const isLoading = isBalancesLoading || isRatesLoading || isNaN(totalBalance);

  return (
    <div className="grid justify-items-center">
      <div className="text-sm font-black font-elza-condensed">
        TOTAL ASSET VALUE
      </div>
      {isLoading ? (
        <Skeleton className="h-9 w-32" />
      ) : (
        <h2 className="text-[2rem] font-bold font-chivo">
          {formatCurrency(totalBalance, currency)}
        </h2>
      )}
    </div>
  );
};

export default TotalBalance;
